import { CreateSecurityShape } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/security.zod';
import { CurrencyType, SecurityType } from '@dealstack/shared/lib/generated';
import { z } from 'zod';

/** The issuer is supplied by the caller, not the form. */
export const CreateSecurityFormShape = CreateSecurityShape.omit({ personId: true });

/** What the caller receives once the shape above has accepted the form. */
export type CreateSecurityFormData = z.infer<typeof CreateSecurityFormShape>;

export interface CreateSecurityFormValues {
	name: string;
	type: SecurityType | null;
	currency: CurrencyType | null;
}

export interface SubmitOptions {
	shouldCloseOnSuccess: boolean;
	resetForm: () => void;
}
